import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import { getMessageForControllingPointsCount } from 'helpers/i18n.jsx'

import { FORT_BATTLE_SERIES_RESULT } from 'constants'
import { POSTBATTLE_SCREEN_HEADER_TITLES } from './constants.jsx'

import styles from './Header.scss'

const Header = (props) => {

    const className = classNames(
        styles.base,
        styles[`base__${props.outcome}`],
    )

    return (
        <div className={className}>
            <div className={styles.outcome}>
                <h1 className={styles.title}>
                    {POSTBATTLE_SCREEN_HEADER_TITLES[props.outcome]}
                </h1>
                <p className={styles.outcomeMessage}>
                    {getMessageForControllingPointsCount(props.pointsUnderControl)}
                </p>
            </div>

            <div className={styles.reward}>
                <div className={styles.earnedResource}>
                    <IndustrialResource value={props.reward} custom />
                </div>
            </div>
        </div>
    )
}

Header.propTypes = {
    outcome: PropTypes.oneOf(Object.values(FORT_BATTLE_SERIES_RESULT)).isRequired,
    pointsUnderControl: PropTypes.number,
    reward: PropTypes.number.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Header/Header.jsx